<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors  : 陈钊贤
 * @Description:
 * @LastEditTime : 2020-01-14 17:54:11
 -->
<template>
  <pi-content className="white">
    <div class="success-box">
      <div class="success-icon">
        <img src="@/assets/img/cash-fail.png"
             alt=""
             class="wh100">
      </div>
      <div class="title">退款申请失败</div>
      <div style="box-sizing: border-box; padding: 0 0.6rem">
        <div class="button1" @click="close">
          返回
        </div>
      </div>

    </div>
  </pi-content>
</template>
<script>
export default {
  name: 'my-cash-success',
  data () {
    return {
    };
  },
  created () {
  },
  methods: {
    close () {
      history.go(-2);
    }
  }
};
</script>
<style lang="less" scoped>
.success-box {
  padding-top: 1rem;
  text-align: center;
  .success-icon {
    width: 3.49rem;
    height: 4.93rem;
    margin: auto;
  }
  .title {
    margin-top: 0.44rem;
    font-size: 0.38rem;
    color: #333333;
  }
  .cash-text {
    margin-top: 0.3rem;
    padding: 0 1.12rem;
    font-size: 0.24rem;;
    color: #999;
    margin-bottom: 0.5rem;
  }
}
.button1{
  height: 0.8rem;
  background: #ABABAB;
  border-radius:40px;
  text-align: center;
  color: white;
  font-size: 0.34rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1.2rem 0.6rem;
}
</style>
